<template>
  <div class="user-detail">
    <Header title="个人中心" :is-nav="true" style="background: white"></Header>
    <div class="content">
      <van-cell-group>
        <div class="img">
          <span>头像</span>
          <van-image :src="headUrl || userInfo.headUrl" @click="openImgPopup">
            <template v-slot:error>
              <van-icon name="photograph" />
            </template>
          </van-image>
        </div>
        <van-field v-model="form.realName" class="field" label="姓名" placeholder="请输入" required />
        <van-field v-model="form.mobilePhone" class="field" label="手机号码" placeholder="请输入" />
        <van-field v-model="form.emailAddress" class="field" label="邮箱" placeholder="请输入" required />
      </van-cell-group>

      <van-cell-group style="margin-top: 32px;">
        <van-field v-model="form.occupation" class="field" label="职业" placeholder="请输入职业" />
        <van-field v-model="form.post" class="field" label="职务" placeholder="请输入职务" />
      </van-cell-group>

      <div class="cont-btn">
        <van-button class="btn" size="large" @click="save">确 定</van-button>
      </div>

    </div>

    <!--图片选择弹窗-->
    <van-popup v-model="show" :style="{ height: '3.4rem', paddingTop: '0.2rem' }" position="bottom">
      <div class="img-choose__popup-option" @click.stop="chooseImg">选择头像</div>
      <div class="img-choose__popup-line"></div>
      <div class="img-choose__popup-option" @click.stop="photo">
        <!--相机-->
        <!--        <van-uploader ref="camera" v-model="fileList" :after-read="afterRead" :max-count="1"
                      :preview-image="false" accept="image/*" capture="camera">-->

        拍照
        <!--        </van-uploader>-->
      </div>
      <div class="img-choose__popup-option" @click.stop="album">
        <!--相册-->
        <!--        <van-uploader ref="album" v-model="fileList" :after-read="afterRead" :max-count="1"
                      :preview-image="false" accept="image/*">-->
        从相册中选择
        <!--        </van-uploader>-->
      </div>
    </van-popup>
    <!--默认图片弹窗-->
    <van-popup v-model="defImgShow" :style="{ height: '100%',width: '100%', background: '#f6f4f5'}" position="right">
      <div class="user-detail">
        <div class="head popup-header">
          <van-row>
            <van-col class="back" span="3"><img class="img" src="@/assets/imgs/nav_icon_back.png" @click.stop="defImgShow = false" /></van-col>
            <van-col span="18">
              <div class="header">选择图片</div>
            </van-col>
            <van-col span="3"></van-col>
          </van-row>
        </div>
        <div class="content" style="background: white">
          <van-row>
            <van-radio-group v-model="defHeadUrl">
              <van-col v-for="(item, index) in avatars" :key="index" span="8">
                <van-radio :class="defHeadUrl === item.itemCode ? 'radio-checked__border' : ''" :name="item.itemCode" checked-color="#ee0a24" icon-size="24px">
                  <img :src="item.itemCode" />
                </van-radio>
              </van-col>
            </van-radio-group>
          </van-row>
        </div>
        <div class="btn-wrap">
          <van-button class="confirm-btn" type="danger" @click="chooseDefImg">确定</van-button>
        </div>
      </div>
    </van-popup>
  </div>

</template>
<script>
// import Header from '../../../components/Header';
import Header from '@/components/Header.vue';
import accountApi from "@/request/accountApi";
import uploadApi from "@/request/uploadApi";
import { setStore } from "@/store/storage.js";
import { getcamera } from "@/request/flutterBrid";

export default {
  components: {
    Header,
  },
  data() {
    return {
      headUrl: "",
      show: false,
      defImgShow: false,
      fileList: [
        // {
        //   url: 'https://img01.yzcdn.cn/vant/leaf.jpg',
        //   status: 'uploading',
        //   message: '上传中...',
        // },
        // {
        //   url: 'https://img01.yzcdn.cn/vant/tree.jpg',
        //   status: 'failed',
        //   message: '上传失败',
        // },
      ],
      value: "",
      activeNames: [],
      username: "",
      phone: "",
      digit: "",
      // form: {
      //   headUrl: "",
      // },
      form: {
        accountName: "",
        // mobilePhone: "",
        realName: "",
        emailAddress: "",
        headUrl: "",
        post: "",
        occupation: "",
      },
      avatars: [],
      defHeadUrl: '',
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  created() {
    Object.keys(this.form).forEach((key) => {
      this.form[key] = this.userInfo[key];
    });
    this.getAvatars();
    // this.form = { ...this.userInfo };
  },
  methods: {
    async getAvatars() {
      let appAvatarRes = await accountApi.getProductLIst({ setCodeList: ["APP_AVATAR"] });
      if (appAvatarRes.returnCode == "0") {
        this.avatars = appAvatarRes.result.APP_AVATAR;
      }
    },
    openImgPopup() {
      this.show = true
      this.fileList = []
    },
    photo() {
      getcamera('1', (result) => {
        this.afterRead(result)
      });
    },
    album() {
      getcamera('2', (result) => {
        this.afterRead(result)
      });
    },
    chooseImg() {
      this.defImgShow = true
    },
    chooseDefImg() {
      this.form.headUrl = this.defHeadUrl
      this.headUrl = this.defHeadUrl
      this.defImgShow = false
      this.show = false
    },
    afterRead(file) {
      if (!file) {
        return
      }
      this.headUrl = file;
      let formData = new FormData();
      formData.append("file", this.$utils.base64ToNeed('file', file));
      uploadApi.uploadFile(formData).then((res) => {
        if (res.data.success) {
          this.form.headUrl = res.data.result.imageUrl;
          this.show = false;
          this.$toast.success('上传成功');
        } else {
          this.form.headUrl = ''
          this.headUrl = ''
          this.fileList = []
          this.$toast.fail(res.returnMessage);
        }
      }).catch(() => {
        this.headUrl = ''
        this.fileList = []
        this.$toast.fail('上传失败');
      });
    },
    // 请求
    async getPersonalDetails() {
      let params = {};
      await accountApi.getPersonalDetails(params).then((result) => {
        console.log("0000", result)
        if (result.returnCode == "0") {
          setStore("userInfo", result.result);
          this.$store.commit("setUserInfo", result.result);
          console.log("userInfo0------", this.userInfo)
        } else {
          this.$toast({ type: 'fail', message: result.returnMessage });
        }
      });

    },
    async save() {
      // this.form.headUrl = this.fileList[0].content;
      let params = Object.assign({}, this.form);
      if (!this.form.realName) {
        this.$toast({
          type: "fail",
          message: "请填写姓名",
          duration: 1500,
        });
        return;
      }
      if (!this.form.emailAddress) {
        this.$toast({
          type: "fail",
          message: "请填写正确的邮箱",
          duration: 1500,
        });
        return;
      }
      accountApi.ediitPersonalDetails(params).then(async (res) => {
        console.log("res", res)
        // res = res.data;
        if (res.returnCode == "0") {
          this.$toast({ type: 'success', message: '保存成功' });
          await this.getPersonalDetails();
          this.$router.push('/personal');
        } else {
          this.$toast({ type: 'fail', message: res.returnMessage });
          this.Modal.isShow = true;
        }
      });
    },
    // 返回布尔值
    beforeRead() {
    },
    // 返回 Promise
    async BeforeRead(file) {
      return new Promise((resolve, reject) => {
        if (file.type !== "image/jpeg") {
          reject();
        } else {
          let img = new File(["foo"], "bar.jpg", {
            type: "image/jpeg",
          });
          resolve(img);
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.user-detail {
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
  background-color F0F1F5

  .content {
    padding-top: 32px;

    .field {
      padding: 0 40px;
      height: 96px;
      line-height: 96px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 28px;
      color: #FF1818;

      >>> .van-field__control {
        text-align: right;
      }
    }

    >>> .van-cell--required::before {
      left: 24px;
      font-size: 36px;
    }

    .img {
      padding: 0 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 28px;
      padding: 28px;
      color: #646566;

      >>> .van-image {
        width: 64px;
        height: 64px;
      }
    }

    .cont-btn {
      width: 100%;
      margin-top: 32px;
      height: 96px;
      line-height: 96px;
      background: #FFFFFF;

      .btn {
        width: 100%;
        height: 96px;
        line-height: 96px;
        text-align: center;
        background: #FFFFFF;
        color: #333333;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 32px;
        border: 1px solid #fff
      }
    }
  }

  .avatar-div >>> .van-uploader__preview-image {
    width: 200px;
    height: 200px;
    display: inline-block;
    margin-top: 10px;
    margin-left: 20px;
  }

  .avatar-div >>> .van-uploader__upload {
    width: 200px;
    height: 200px;
    margin-left: 20px;
  }

  .avatar {
    background: #fff;
    margin-top: 20px;
    font-size: 32px;
    padding-bottom: 30px;

    .van-image {
      vertical-align: middle;
    }

    p {
      margin-left: 20px;
      height: 50px;
      line-height: 50px;
    }

    .avatar-div {
      margin-left: 90px;
    }

    .avatar-uploader {
      vertical-align: middle;

      .van-uploader__wrapper {
      }

      .van-uploader__upload {
      }

      .van-image__img {
        width: 600px;
        height: 600px;
      }

      .van-uploader__preview-image {
        width: 600px;
        height: 600px;
      }
    }
  }
}

.img-choose__popup-option {
  height: 1rem;
  line-height: 1rem;
  font-size: 0.24rem;
  text-align: center;
  letter-spacing: 0.02rem;
}

.img-choose__popup-line {
  border-top: 0.04rem solid #dcdee0;
  width: 94%;
  margin-left: 3%;
}

.back {
  padding-left: 20px;
}

img {
  vertical-align: middle;
  width: 24.83px;
  height: 45.66px;
  line-height: 88px;
}

.header {
  line-height: 88px;
  text-align: center;
  font-weight: bold;
  color: #000;
  font-size: 32px;
  display: inline-block;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.popup-header {
  background: white;
  border-bottom: 0.05rem solid #dcdcdc;
}

.btn-wrap {
  display: flex;
  justify-content: center;
  padding: 0 64px;
  margin-top: 0.2rem;

  .confirm-btn {
    width: 100%;
    height: 90px;
    border-radius: 24px;
    background: #d9001b;
    color: rgba(255, 255, 255, 1);
    font-size: 32px;
    font-family: PingFangSC-Semibold;
    letter-spacing: 0.2rem;
  }
}
</style>
